export const CHANGE_FOR_ANY_REASON_TITLE = "Change for Any Reason (Flights)";
export const CHANGE_FOR_ANY_REASON_SUBTITLE = "Terms and Conditions";
